<template>
    <onsitetemplate-editor></onsitetemplate-editor>
</template>

<script>
export default {
	mounted() {
		this.$store.dispatch("audit/template/resetState")
	}
}
</script>